module.exports = __webpack_public_path__ + "img/bjb.e08dad3c.svg";